export const isInteger = (numberOrString: string | number | undefined): boolean => {
    if (numberOrString == null) {
        return false;
    }
    return Number.isInteger(typeof numberOrString === 'number' ? numberOrString : parseFloat(numberOrString));
};
